export function formatTimeLeft(expiresAt: string | null | undefined): string | null {
  if (!expiresAt) return null;
  const exp = new Date(expiresAt);
  const diffMs = exp.getTime() - Date.now();

  if (diffMs <= 0) return 'Expired';

  const diffMins = Math.floor(diffMs / 60_000);
  const diffHours = Math.floor(diffMs / 3_600_000);
  const diffDays = Math.floor(diffMs / 86_400_000);

  if (diffMins < 60) return `${diffMins} minute${diffMins !== 1 ? 's' : ''} left`;
  if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? 's' : ''} left`;
  if (diffDays < 7) return `${diffDays} day${diffDays !== 1 ? 's' : ''} left`;
  return `Expires ${exp.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}`;
}
